(function(){
	'use strict';
	angular.module('app.dashboard')
		.service('dashboardCreationService', dashboardCreationService);

	dashboardCreationService.$inject = ['$http', '$q', 'URLS', 'storeService'];
	function dashboardCreationService($http, $q, URLS, storeService) {
		return {
			createDashboard: createDashboard
		};

		function createDashboard(newDashboard, callback) {
			var isCT = newDashboard.baseReportName === 'Control tower';
			var isPerfDashboard = newDashboard.baseReportName === 'Performance metrics';
			if (isCT || isPerfDashboard) {
				var promises = {};
				var typesUrl = String.format(URLS.metricTypes, globalConfig.factory.id.toString());
				var timePeriodFilter = {};
				var typeFilter = {};

				// make API calls to get type and date range data
				promises.types = $http.get(URLS.host + typesUrl);
				if (isPerfDashboard) {
					promises.timePeriod = $http.get(URLS.apiPrefix + globalConfig.factory.id + '/MetricDateRange');
				}
				$q.all(promises).then(function(responses) {
					if (responses.types && responses.types.data) {
						var level1 = _.find(responses.types.data, {typeName: 'Level1'});
						if (level1 ||  responses.types.data.length) {
							typeFilter.id = 'typeName';
							typeFilter.values = [level1 ? level1.typeName : responses.types.data[0].typeName];
						}
					}
					timePeriodFilter.id = isPerfDashboard ? 'timePeriod' : 'controlTowerTimePeriod';
					if (isCT) {
						timePeriodFilter.values = responses.timePeriod && responses.timePeriod.data 
							? [responses.timePeriod.data.value] 
							: ['Current'];
					} else if (isPerfDashboard) {
						timePeriodFilter.value = responses.timePeriod && responses.timePeriod.data 
							? responses.timePeriod.data.value
							: 'current';
					}
					completeSave(newDashboard, typeFilter, timePeriodFilter, callback);
				});
			} else {
				completeSave(newDashboard, undefined, undefined, callback);
			}
		}

		function completeSave(newDashboard, optionalTypeFilter, optionalTimePeriodFilter, callback) {
			if (optionalTypeFilter && optionalTypeFilter.values) {
				newDashboard.filters.push(optionalTypeFilter);
			}
			if (optionalTimePeriodFilter && optionalTimePeriodFilter.values) {
				newDashboard.filters.push(optionalTimePeriodFilter);
			}
			return storeService.dispatch(storeService.postNewView(newDashboard)).then(function(response) {
				callback(response, newDashboard);
			});
		}
	}
})();